import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { motion } from "@smartsheet/design-tokens";
import { sizes } from "../../../../constants/spacing";
import { createFocusRingStyles } from "../../../../util/createFocusRingStyles";
import { Clickable } from "../../../clickable";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { selectV2Theme } from "../selectV2Theme";
export var ActionButtonBaseCss = function ActionButtonBaseCss(_ref) {
  var themeMode = _ref.themeMode;
  return {
    display: "inline-flex",
    alignItems: "center",
    boxSizing: "border-box",
    cursor: "pointer",
    height: selectV2Theme.actionButtons.size(themeMode),
    width: selectV2Theme.actionButtons.size(themeMode),
    margin: 0,
    padding: "".concat(sizes.xxSmall, "px"),
    border: "none",
    borderRadius: selectV2Theme.actionButtons.borderRadius(themeMode),
    fontWeight: 600,
    color: "currentColor",
    justifyContent: "space-around",
    whiteSpace: "nowrap",
    backgroundColor: "transparent",
    transition: "background-color ".concat(motion.animation.default)
  };
};
export var ActionButton = styled(Clickable)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n\n    ", "\n    background-color: ", "\n"])), ActionButtonBaseCss, function (_ref2) {
  var omitFocusRing = _ref2.omitFocusRing,
    themeMode = _ref2.themeMode;
  return omitFocusRing ? "" : createFocusRingStyles({
    theme: themeMode,
    // We want these outlines to sit within the button's content box.
    gap: -2,
    focusSelector: ":focus-visible",
    componentBorderWidth: 0,
    componentRadius: formInputTheme.borderRadius(themeMode)
  });
}, function (_ref3) {
  var isHovered = _ref3.isHovered,
    isOpen = _ref3.isOpen,
    isActive = _ref3.isActive,
    themeMode = _ref3.themeMode;
  if (isHovered && !isActive) {
    return "".concat(selectV2Theme.actionButtons.background.hover(themeMode), ";");
  }
  if (isOpen || isActive) {
    return "".concat(selectV2Theme.actionButtons.background.active(themeMode), ";");
  }
  return "";
});
ActionButton.displayName = "ActionButton";
//# sourceMappingURL=ActionButton.js.map